import {SparkSwiperSlideController} from "../../../../components/spark-swiper/models/spark-swiper-slide-controller";
import {IVideoPlayerViewModel} from "../../../video/models/video-player.view-model.interface";
import React from "react";
import {IVideoSwiperSlideController} from "../video-swiper-slide-controller.interface";
import {ISparkSwiperController} from "../../../../components/spark-swiper/models/spark-swiper-controller.interface";
import {VideoSlidesService} from "../../video-slides.service";
import {SwipeDirectionEnum} from "../../../../components/spark-swiper/models/spark-swiper-slide-controller.interface";
import {ISlideRenderer} from "../../video-slides.service.interface";

export class VideoSlidesSwiperSlideController extends SparkSwiperSlideController implements IVideoSwiperSlideController {

    constructor(id: string,
                controller: ISparkSwiperController,
                private readonly videoSlides: VideoSlidesService) {
        super(id, controller);
        this.videoPlayer = videoSlides.createVideoPlayer();
    }

    public readonly videoPlayer: IVideoPlayerViewModel

    get realIndex(): number {
        return this.itemIndex % this.videoSlides.slidesRenderers.length;
    }

    private _executeForRenderer<T>(action: (renderer: ISlideRenderer) => T): T | null {
        const renderer = this.videoSlides.slidesRenderers[this.realIndex];
        if(renderer) {
            return action(renderer);
        } else {
            //we can reach here if we have a bug in the spark swiper, but if this happens we don't want to crash the whole app because of this.
            this.videoSlides.logger.error(`Invalid video slides renderer index ${this.realIndex} | renderersCount = ${this.videoSlides.slidesRenderers.length}`);
            return null;
        }
    }

    renderSlideContent(): React.ReactElement {
        return this._executeForRenderer(renderer => renderer.render(this));
    }

    onBeforeDeactivate(swipeDirection: SwipeDirectionEnum) {
        this._executeForRenderer(renderer => renderer.onBeforeDeactivate({
            swipeDirection: swipeDirection
        }))
    }

    onAfterActivated(swipeDirection: SwipeDirectionEnum) {
        this._executeForRenderer(renderer => renderer.onAfterActivated({
            swipeDirection: swipeDirection
        }));
    }

}